import { Template } from "@suse-o11y/template";
import { z } from "zod";

const FALLBACK_DASHBOARD_WIDGET_LINK_URL = Template<null>("");
const FALLBACK_DASHBOARD_WIDGET_LINK = {
	url: FALLBACK_DASHBOARD_WIDGET_LINK_URL,
};

const schema = z
	.object({
		url: z
			.string()
			.trim()
			.min(1)
			.transform((url) => Template<null>(url))
			.catch(FALLBACK_DASHBOARD_WIDGET_LINK_URL),

		name: z
			.string()
			.trim()
			.transform((name) => Template<null>(name))
			.optional()
			.catch(undefined),

		tooltip: z
			.string()
			.trim()
			.transform((tooltip) => Template<null>(tooltip))
			.optional()
			.catch(undefined),

		targetBlank: z.boolean().optional().catch(undefined),
	})
	.catch(FALLBACK_DASHBOARD_WIDGET_LINK);

type DashboardWidgetLink = z.infer<typeof schema>;

const DashboardWidgetLink = { schema };

export { DashboardWidgetLink };
